import ArticleCard from '@components/article-card/article-card.view';

export default ArticleCard;
